var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"content",domProps:{"innerHTML":_vm._s(_vm.content)}}),_c('mainFooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }